// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_message {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  outline: 0;
}

.popup_message_content {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%) !important;
  margin: 0 auto;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.popup_container {
  padding: 20px;
  width: 500px;
  border: 1px solid var(--border-color);
}

.popup_container_with_increase {
  padding: 20px;
  width: 800px;
  border: 1px solid var(--border-color);
}

.popup_btn_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  margin-top: 20px;
}

.popup_delecte_btn {
  background-color: red !important;
  color: white !important;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/PopupMessage/PopupMessage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".popup_message {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: hidden;\n  outline: 0;\n}\n\n.popup_message_content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 9999999;\n  transform: translate(-50%, -50%) !important;\n  margin: 0 auto;\n  background-color: white;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n\n.popup_container {\n  padding: 20px;\n  width: 500px;\n  border: 1px solid var(--border-color);\n}\n\n.popup_container_with_increase {\n  padding: 20px;\n  width: 800px;\n  border: 1px solid var(--border-color);\n}\n\n.popup_btn_wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n  margin-top: 20px;\n}\n\n.popup_delecte_btn {\n  background-color: red !important;\n  color: white !important;\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
